import { useTheme } from "@compass/core";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useMediaQuery } from "@mui/material";

export const useNavigationBar = (): {
  isNavBarDrawer: boolean;
  showPin: boolean;
} => {
  const theme = useTheme();
  const navPinned = useSelector((state: RootState) => state.userSetting.navPinned);

  const isNavBarDrawer = !useMediaQuery(theme.breakpoints.up("lg")) || !navPinned;
  const showPin = useMediaQuery(theme.breakpoints.up("lg"));

  return {
    isNavBarDrawer: isNavBarDrawer,
    showPin: showPin
  };
};
